import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Table, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import SidebarLayout from "../components/shared/SidebarLayout";
import { useTranslation } from "react-i18next";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import PhoneInput from "react-phone-input-2";
import { Controller, useForm } from "react-hook-form";
import { isEmpty, pick } from "lodash";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { t } from "i18next";
const ResetPassword = () => {
  const navigate = useNavigate();
  const preventMaxInput = (e) => {
    e.target.value = e.target.value.trimStart();
    e.target.value = e.target.value.replace(/  +/g, " ");
  };
  const [isLoader, setIsLoader] = useState(false);
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const [showPassword, setShowPassword] = useState({
    first: false,
    second: false,
    third: false,
  });
  const handleShow = (id) => {
    setShowPassword({ ...showPassword, [id]: !showPassword[id] });
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useForm({});
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("newPassword")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("newPassword")]);
  const onSubmit = async (body) => {
    setIsLoader(true);
    const obj = pick(body, ["oldPassword", "newPassword"]);
    const { status, data } = await apiPost(apiPath.changePassword, obj);
    if (status === 200) {
      if (data.success) {
        logoutUser();
        navigate("/");
      } else {
        toast.error(data?.message);
        setIsLoader(false);
      }
    } else {
      toast.error(data?.message);
      setIsLoader(false);
    }
  };
  return (
    <SidebarLayout heading={"Reset Password"}>
      <div className="registration-form active">
        <div style={{ padding: "10px" }} className="reg-data">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <Form.Group
                style={{ padding: "0" }}
                className="d-flex login-data-d"
              >
                <div style={{ position: "relative", width: `100%` }}>
                  <i class="input-icon icon_password">
                    <svg class="am-icon am-icon-form-icon-password_e999b917 am-icon-md">
                      <use xlinkHref="#form-icon-password_e999b917"></use>
                    </svg>
                  </i>
                  <Form.Control
                    type={showPassword.first ? "text" : "password"}
                    placeholder={"Current Password"}
                    {...register("oldPassword", {
                      required: "Please enter current password",
                      minLength: {
                        value: 8,
                        message: "Password should contain atleast 8 characters",
                      },
                      maxLength: {
                        value: 16,
                        message:
                          "Password should contain maximum 16 characters",
                      },
                    })}
                  />

                  <div
                    className="input-group-btn"
                    style={{
                      position: "absolute",
                      right: "0",
                      top: "-10",
                      bottom: "8px",
                    }}
                  >
                    <span
                      className="btn btn-outline-primary"
                      onClick={() => handleShow("first")}
                      style={{
                        backgroundColor: "transparent",
                        border: "0",
                        padding: "17px",
                        paddingTop: "3px",
                        height: "72%",
                      }}
                    >
                      {showPassword.first ? (
                        <AiFillEyeInvisible color="#23ffc8" />
                      ) : (
                        <AiFillEye color="#23ffc8" />
                      )}
                    </span>
                  </div>
                </div>
              </Form.Group>
              {errors.oldPassword && errors.oldPassword.message && (
                <div className="text-danger">{errors.oldPassword.message}</div>
              )}
              <Form.Group
                style={{ padding: "0" }}
                className="d-flex  login-data-d"
              >
                <div style={{ position: "relative", width: `100%` }}>
                  <i class="input-icon icon_password">
                    <svg class="am-icon am-icon-form-icon-password_e999b917 am-icon-md">
                      <use xlinkHref="#form-icon-password_e999b917"></use>
                    </svg>
                  </i>
                  <Form.Control
                    type={showPassword.second ? "text" : "password"}
                    placeholder={"New Password"}
                    {...register("newPassword", {
                      required: "Please enter new password",
                    })}
                  />

                  <div
                    className="input-group-btn"
                    style={{
                      position: "absolute",
                      right: "0",
                      top: "-10",
                      bottom: "8px",
                      // filter: `invert(1)`,
                    }}
                  >
                    <span
                      className="btn btn-outline-primary"
                      onClick={() => handleShow("second")}
                      style={{
                        backgroundColor: "transparent",
                        border: "0",
                        padding: "17px",
                        paddingTop: "3px",
                        height: "72%",
                      }}
                    >
                      {showPassword.second ? (
                        <AiFillEyeInvisible color="#23ffc8" />
                      ) : (
                        <AiFillEye color="#23ffc8" />
                      )}
                    </span>
                  </div>
                </div>
              </Form.Group>
              {errors.newPassword && errors.newPassword.message && (
                <div className="text-danger">{errors.newPassword.message}</div>
              )}

              <Form.Group
                style={{ padding: "0" }}
                className="d-flex  login-data-d"
              >
                <div style={{ position: "relative", width: `100%` }}>
                  <i class="input-icon icon_password">
                    <svg class="am-icon am-icon-form-icon-password_e999b917 am-icon-md">
                      <use xlinkHref="#form-icon-password_e999b917"></use>
                    </svg>
                  </i>
                  <Form.Control
                    type={showPassword.third ? "text" : "password"}
                    placeholder={"Confirm Password"}
                    {...register("confirmPassword", {
                      required: "Please enter confirm password",
                      validate: (value) => {
                        if (value === "") {
                          return true;
                        }
                        if (!isEmpty(watch("newPassword"))) {
                          if (value == watch("newPassword")) {
                            return true;
                          } else {
                            return "New password and confirm password should be same";
                          }
                        }
                      },
                    })}
                  />

                  <div
                    className="input-group-btn"
                    style={{
                      position: "absolute",
                      right: "0",
                      top: "-10",
                      bottom: "8px",
                    }}
                  >
                    <span
                      className="btn btn-outline-primary"
                      onClick={() => handleShow("third")}
                      style={{
                        backgroundColor: "transparent",
                        border: "0",
                        padding: "17px",
                        paddingTop: "3px",
                        height: "72%",
                      }}
                    >
                      {showPassword.third ? (
                        <AiFillEyeInvisible color="#23ffc8" />
                      ) : (
                        <AiFillEye color="#23ffc8" />
                      )}
                    </span>
                  </div>
                </div>
              </Form.Group>
              {errors.confirmPassword && errors.confirmPassword.message && (
                <div className="text-danger">
                  {errors.confirmPassword.message}
                </div>
              )}
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isLoader ? "disabled" : ""}
            >
              <span> {isLoader ? "Loading..." : "Submit"}</span>
            </button>
          </Form>
        </div>
      </div>
    </SidebarLayout>
  );
};

export default ResetPassword;
